import {
  HomeIcon,
  HotelIcon,
  CustomerServicesIcon,
  RoomServiceIcon,
  ChatBubbleLeftIcon,
  AdjustmentsHorizontalIcon,
  MessageIcon,
  BookIcon,
} from "components/Icons";

const MELHOUS_MODEL = "melhous";

const VIEW_HOME = "home";
const VIEW_HOTEL = "hotel";
const VIEW_ENGAGE = "engage";
const VIEW_REQUESTS = "requests";
const VIEW_PQRS = "pqrs";
const VIEW_APPEARANCE = "appearance";

const MELHOUS_TABS = [
  { id: VIEW_HOME, label: "melhous.dash.tab.home", Icon: HomeIcon },
  { id: VIEW_HOTEL, label: "melhous.dash.tab.hotel", Icon: HotelIcon },
  {
    id: VIEW_ENGAGE,
    label: "melhous.dash.tab.engage",
    Icon: CustomerServicesIcon,
  },
  {
    id: VIEW_REQUESTS,
    label: "melhous.dash.tab.requests",
    Icon: RoomServiceIcon,
  },
  { id: VIEW_PQRS, label: "melhous.dash.tab.pqrs", Icon: ChatBubbleLeftIcon },
  {
    id: VIEW_APPEARANCE,
    label: "melhous.dash.tab.appearance",
    Icon: AdjustmentsHorizontalIcon,
  },
];

const HOME_CARDS = [
  {
    id: "pending_requests",
    label: "melhous.dash.card.pending_requests",
    model: "melhous.request",
    domain: [["state", "=", "pending"]],
    view: VIEW_REQUESTS,
    Icon: RoomServiceIcon,
  },
  {
    id: "active_messages",
    label: "melhous.dash.card.active_messages",
    model: "melhous.message",
    domain: [["active", "=", true]],
    view: VIEW_ENGAGE,
    Icon: MessageIcon,
  },
  {
    id: "guide_items",
    label: "melhous.dash.card.guide_items",
    model: "melhous.guide_item",
    domain: [],
    view: VIEW_ENGAGE,
    Icon: BookIcon,
  },
  {
    id: "open_pqrs",
    label: "melhous.dash.card.open_pqrs",
    model: "crm.customer_service",
    domain: [["state", "in", ["draft", "open"]]],
    view: VIEW_PQRS,
    Icon: ChatBubbleLeftIcon,
  },
];

const QR_LINKS = [
  { path: "", name: "qrMelhous", label: "melhous.dash.qr.melhous" },
  { path: "/shops", name: "qrRestaurant", label: "melhous.dash.qr.restaurant" },
  { path: "/hotel", name: "qrHotel", label: "melhous.dash.qr.hotel" },
];

const COLOR_FIELDS = [
  "primary_color",
  "secondary_color",
  "accent_color",
  "text_color",
  "surface_color",
  "border_color",
];

const SECTION_FIELDS = [
  "show_hotel",
  "show_restaurant",
  "show_pqrs",
  "show_reservation",
  "show_experiences",
];

const APPEARANCE_FIELDS = [...COLOR_FIELDS, ...SECTION_FIELDS, "logo_link"];

const HEX_COLOR_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const DEFAULT_PICKER_COLOR = "#ffffff";

const WCAG_AA_RATIO = 4.5;

const SUGGESTED_COLORS = [
  "#1f3a5f",
  "#0e2d1b",
  "#982f2f",
  "#ff5733",
  "#f2a541",
  "#d4af37",
  "#2a9d8f",
  "#7bbb4b",
  "#6c5ce7",
  "#1a1a1a",
  "#e5e7eb",
  "#ffffff",
];

export {
  COLOR_FIELDS,
  SECTION_FIELDS,
  APPEARANCE_FIELDS,
  HEX_COLOR_REGEX,
  DEFAULT_PICKER_COLOR,
  WCAG_AA_RATIO,
  SUGGESTED_COLORS,
  MELHOUS_MODEL,
  VIEW_HOME,
  VIEW_HOTEL,
  VIEW_ENGAGE,
  VIEW_REQUESTS,
  VIEW_PQRS,
  VIEW_APPEARANCE,
  MELHOUS_TABS,
  HOME_CARDS,
  QR_LINKS,
};
